import React from 'react'

const ForgotPassword = props => {
  return (
    <div className="island">
      <form onSubmit={props.submit}>
        <div className="form-item form-type-textfield form-item-name">
          <label htmlFor="edit-name">Username or e-mail address <span className="form-required" title="This field is required.">*</span></label>
          <input type="text" id="email" onChange={props.change} name="email" className="form-text" />
        </div>
        <div className="form-actions form-wrapper" id="edit-actions">
          <input type="submit" id="edit-submit" name="op" value="E-mail new password" className="form-submit" />
        </div>
      </form>
    </div>
  )
}

export default ForgotPassword
